import Request from "../@api/Request";

const request = new Request(process.env.REACT_APP_API_HOST);

export default class GameService {
  static async getGame(gameId: string) {
    const result = await request.get(`/game/play/${gameId}`);
    return result;
  }

  static async getComparison(comparisonId: string) {
    const result = await request.get(`/game/comparison/${comparisonId}`);
    return result;
  }

  static async getUser(gameId: string) {
    const result = await request.get(`/game/user/${gameId}`);
    return result;
  }

  static async checkGameId(gameId: string) {
    const result = await request.get(`/game/check/game-id/${gameId}`);
    return result;
  }

  static async checkComparisonId(comparisonId: string) {
    const result = await request.get(`/game/check/comparison-id/${comparisonId}`);
    return result;
  }

  static async createGame(
    gameId: string,
    name: string,
    goal: string,
    policy: string,
    pyi: number,
    debt: string,
    debtGoal: number,
    score: string
  ) {
    const result = await request.post(`/game/play`, {
      gameId,
      name,
      goal,
      policy,
      pyi,
      debt,
      debtGoal,
      score,
    });
    return result;
  }

  static async createComparison(comparisonId: string, gameIds: string[]) {
    console.log(comparisonId);
    console.log(gameIds);
    const result = await request.post(`/game/comparison`, { comparisonId, gameIds });
    return result;
  }

  static async createUser(gameId: string, userName: string, email: string, organization: string) {
    const result = await request.post(`/game/user`, { gameId, userName, email, organization });
    return result;
  }

  static async updateGame(
    gameId: string,
    name: string,
    goal: string,
    policy: string,
    pyi: number,
    debt: string,
    debtGoal: number,
    score: string
  ) {
    const result = await request.put(`/game/play`, {
      gameId,
      name,
      goal,
      policy,
      pyi,
      debt,
      debtGoal,
      score,
    });
    return result;
  }

  static async updateComparison(comparisonId: string, gameIds: string[]) {
    console.log(comparisonId);
    console.log(gameIds);
    const result = await request.put(`/game/comparison`, { comparisonId, gameIds });
    return result;
  }

  static async updateUser(gameId: string, userName: string, email: string, organization: string) {
    const result = await request.put(`/game/user`, { gameId, userName, email, organization });
    return result;
  }
}
